import React, {useState} from "react";
import {C} from "../styles";
import {apiAdminUploadLandingImage} from "../api/landing";
import {buildNewsImageUrl} from "../utils";

// Champ « image » d'un bloc : envoi d'un fichier vers le serveur (JPEG/PNG/WebP, 5 Mo max, converti en WebP), qui renvoie
// l'URL /uploads/landing/<id>.webp stockée dans la page. Aucune image externe n'est acceptée.
export default function ImageField({value, onChange}) {
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState("");

    async function handleFileChange(e) {
        const file = e.target.files && e.target.files[0];
        if (!file) return;
        setUploading(true);
        setError("");
        const result = await apiAdminUploadLandingImage(file);
        setUploading(false);
        if (!result || result.error || !result.url) {
            setError((result && (result.message || result.error)) || "Envoi impossible");
            return;
        }
        onChange(result.url);
    }

    return (
        <div>
            {value && (
                <div style={{marginBottom: 8}}>
                    <img src={buildNewsImageUrl(value)} alt="" style={{maxWidth: 200, maxHeight: 140, borderRadius: 8, display: "block", marginBottom: 6}}/>
                    <button type="button" onClick={() => onChange("")}
                            style={{border: `1px solid ${C.border}`, background: "#fff", borderRadius: 6, padding: "4px 9px", cursor: "pointer", fontSize: 13}}>
                        Retirer l'image
                    </button>
                </div>
            )}
            <label style={{display: "inline-block", cursor: "pointer"}}>
                <span style={{border: `1px solid ${C.border}`, borderRadius: 8, padding: "8px 12px", display: "inline-block", fontSize: 14}}>
                    {uploading ? "Envoi en cours…" : (value ? "Remplacer l'image" : "Choisir une image")}
                </span>
                <input
                    type="file"
                    accept="image/jpeg,image/png,image/webp"
                    aria-label="Choisir une image"
                    onChange={handleFileChange}
                    disabled={uploading}
                    style={{position: "absolute", width: 1, height: 1, opacity: 0, overflow: "hidden"}}
                />
            </label>
            {error && <p role="alert" style={{color: C.danger, margin: "6px 0 0", fontSize: 13}}>{error}</p>}
        </div>
    );
}
